import type { SelectOption } from '../../../../components/inputs/Select';

function pick<T>(items: readonly T[]): T | undefined {
  return items.length === 0 ? undefined : items[Math.floor(Math.random() * items.length)];
}

/** A calendar date some weeks ahead, `YYYY-MM-DD` built from local y/m/d — never the instant path. */
function weeksAhead(weeks: number): string {
  const date = new Date();
  date.setHours(12, 0, 0, 0);
  date.setDate(date.getDate() + weeks * 7);

  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/**
 * A request filled from the LIVE pickers, so every id is a row the server accepts. Nothing lands
 * in the identity store — the employee is an existing record picked from the list. On an edit the
 * employee and the category are already decided and the caller keeps them.
 */
export function sampleAttritionRequest(options: { staff: SelectOption[]; categories: SelectOption[] }) {
  return {
    personnelId: pick(options.staff)?.value ?? null,
    attritionCategoryId: pick(options.categories)?.value ?? null,
    effectiveDate: weeksAhead(4 + Math.floor(Math.random() * 8)),
    remarks: 'Sample request. Delete it once the real ones are in.',
  };
}
